(function () {
  var privacyReady = false;
  var attributionStarted = false;
  var inFlight = null;
  var sendCurrentAttrs = null;

  function marketingAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.marketingAllowed !== 'function' || privacy.marketingAllowed() !== true) {
        return false;
      }
      if (typeof privacy.currentVisitorConsent === 'function') {
        var consent = privacy.currentVisitorConsent();
        return !!(consent && consent.marketing === 'yes');
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  function startIfAllowed() {
    if (attributionStarted || !privacyReady || !marketingAllowed()) return;
    attributionStarted = true;
    runAttribution();
  }

  window.__rrFlushAttrs = function () {
    if (!privacyReady || !marketingAllowed() || typeof sendCurrentAttrs !== 'function') {
      return Promise.resolve(false);
    }
    return sendCurrentAttrs(true);
  };

  document.addEventListener('visitorConsentCollected', function () {
    privacyReady = true;
    startIfAllowed();
  });

  try {
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (error) return;
          privacyReady = true;
          startIfAllowed();
        }
      );
    } else if (
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.marketingAllowed === 'function'
    ) {
      privacyReady = true;
      startIfAllowed();
    }
  } catch (e) { }

  function runAttribution() {
    try {
      // ─── Storage helpers ───────────────────────────────────────────────────────
      function lsGet(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
      function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) { } }

      // ─── Keys ─────────────────────────────────────────────────────────────────
      var FT_KEY      = 'rr_ft_v1';
      var LT_KEY      = 'rr_lt_v1';
      var SENT_KEY    = 'rr_cart_attrs_sent_v1';
      var VISITS_KEY  = 'rr_visits_v1';
      var SESSION_KEY = 'rr_session_v1'; // sessionStorage → reset ad ogni nuova sessione

      // ─── Shopify root (multilingua / mercati) ──────────────────────────────────
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

      // ─── Query string & referrer ───────────────────────────────────────────────
      var u   = new URL(location.href);
      var p   = u.searchParams;
      var qs  = location.search || '';

      var rawRef  = document.referrer || '';
      var refHost = '';
      try { if (rawRef) refHost = (new URL(rawRef)).hostname; } catch (e) { }
      var isExternalRef = !!(refHost && refHost !== location.hostname);

      // ─── Parametri paid / UTM / ValueTrack ────────────────────────────────────
      var clickId       = p.get('gclid') || p.get('wbraid') || p.get('gbraid') || '';
      var utm_source    = p.get('utm_source')    || '';
      var utm_medium    = p.get('utm_medium')    || '';
      var utm_campaign  = p.get('utm_campaign')  || '';
      var utm_term      = p.get('utm_term')      || '';
      var utm_content   = p.get('utm_content')   || '';
      var vt_device     = p.get('device')        || '';
      var vt_devicemodel= p.get('devicemodel')   || '';
      var vt_product_id = p.get('product_id')    || '';

      // ─── Segnali di traffico ───────────────────────────────────────────────────
      var hasAnyParam = !!(clickId || utm_source || utm_medium || utm_campaign ||
                          vt_device || vt_devicemodel || vt_product_id);

      var hasTrafficSignal = !!(hasAnyParam || isExternalRef);
      var sentPayload = lsGet(SENT_KEY);
      var skipAutomatic = !hasTrafficSignal && !!sentPayload;

      // ─── Referrer host (max 120 char) ──────────────────────────────────────────
      var ref = isExternalRef ? refHost.slice(0, 120) : '';

      // ─── Search engine heuristic ───────────────────────────────────────────────
      var isSearch = isExternalRef && (
        /(^|\.)google\./i.test(refHost)         ||
        /(^|\.)bing\.com$/i.test(refHost)       ||
        /(^|\.)duckduckgo\.com$/i.test(refHost) ||
        /(^|\.)search\.yahoo\.com$/i.test(refHost) ||
        /(^|\.)ecosia\.org$/i.test(refHost)
      );

      // ─── Landing page pulita (origin + path) ──────────────────────────────────
      var landing = u.origin + u.pathname;

      // ─── Bucket canale ────────────────────────────────────────────────────────
      function bucketFor() {
        if (clickId) return 'paid_google';
        var src = utm_source.toLowerCase();
        var med = utm_medium.toLowerCase();
        // Paid social riconoscibili
        if (src === 'facebook' || src === 'instagram' || src === 'fb') return 'paid_meta';
        if (src === 'tiktok')    return 'paid_tiktok';
        if (src === 'pinterest') return 'paid_pinterest';
        if (src === 'twitter' || src === 'x') return (med === 'paid_social' || med === 'cpc') ? 'paid_x' : 'social_x';
        if (src === 'snapchat')  return 'paid_snapchat';
        if (src === 'youtube')   return (med === 'cpc' || med === 'paid_video') ? 'paid_youtube' : 'social_youtube';
        // Paid generico
        if (med === 'cpc' || med === 'ppc' || med === 'paid_search') return 'paid_other';
        // UTM presenti ma non paid
        if (utm_source || utm_medium) return src + '|' + (med || 'na');
        // Referrer
        if (isExternalRef) return isSearch ? 'organic_search' : 'referral|' + refHost.replace(/^www\./, '');
        return 'direct';
      }

      // ─── Dispositivo lato JS (fallback se ValueTrack non disponibile) ──────────
      function detectDevice() {
        if (vt_device) return vt_device; // ValueTrack ha priorità
        var ua = navigator.userAgent || '';
        if (/tablet|ipad/i.test(ua)) return 'tablet';
        if (/mobile|android|iphone|ipod/i.test(ua)) return 'mobile';
        return 'desktop';
      }

      // ─── Prodotto dalla URL (es. /products/nome-prodotto) ─────────────────────
      function detectProductFromPath() {
        var match = u.pathname.match(/\/products\/([^/?#]+)/);
        return match ? match[1].slice(0, 80) : '';
      }

      // ─── Gestione sessione (sessionStorage → si azzera alla chiusura tab) ──────
      var isNewSession = false;
      if (!skipAutomatic) {
        try {
          if (!sessionStorage.getItem(SESSION_KEY)) {
            sessionStorage.setItem(SESSION_KEY, '1');
            isNewSession = true;
          }
        } catch (e) { isNewSession = true; }
      }

      // ─── Contatore visite (sessioni) ───────────────────────────────────────────
      var visitCount = parseInt(lsGet(VISITS_KEY) || '0');
      if (isNewSession) {
        visitCount += 1;
        lsSet(VISITS_KEY, String(visitCount));
      }

      // ─── Timestamp ISO ────────────────────────────────────────────────────────
      var nowISO = new Date().toISOString();
      var nowMs  = Date.now();

      // ─── Costruisci oggetto touch ──────────────────────────────────────────────
      function buildTouch() {
        return {
          landing:      landing,
          ref:          ref,
          bucket:       bucketFor(),
          ts:           nowMs,
          ts_iso:       nowISO,
          utm_source:   utm_source,
          utm_medium:   utm_medium,
          utm_campaign: utm_campaign,
          utm_term:     utm_term,
          utm_content:  utm_content,
          device:       detectDevice(),
          devicemodel:  (vt_devicemodel || '').slice(0, 80),
          product_id:   vt_product_id || detectProductFromPath()
        };
      }

      // ─── First touch (immutabile) ──────────────────────────────────────────────
      var ftRaw = lsGet(FT_KEY);
      var ft = null;
      try { ft = ftRaw ? JSON.parse(ftRaw) : null; } catch (e) { ft = null; }
      if (!ft) {
        ft = buildTouch();
        lsSet(FT_KEY, JSON.stringify(ft));
      }

      // ─── Last touch (aggiorna solo se segnale di traffico) ────────────────────
      var ltRaw = lsGet(LT_KEY);
      var lt = null;
      try { lt = ltRaw ? JSON.parse(ltRaw) : null; } catch (e) { lt = null; }

      if (!lt) {
        lt = buildTouch();
        lsSet(LT_KEY, JSON.stringify(lt));
      } else if (hasTrafficSignal) {
        lt = buildTouch();
        lsSet(LT_KEY, JSON.stringify(lt));
      }

      // ─── Salva gclid separatamente (compatibilità con altri script Google) ──────
      if (clickId) lsSet('google_click_id', clickId);

      // ─── Calcolo tempo tra first e last touch (in ore) ────────────────────────
      var daysSinceFt = ft.ts ? Math.round((nowMs - ft.ts) / 86400000) : 0;

      // ─── Attributi carrello → order attributes ─────────────────────────────────
      var attrs = {
        // Google Ads
        google_click_id:    clickId || undefined,

        // First touch
        ft_bucket:          ft.bucket,
        ft_landing:         ft.landing,
        ft_ref:             ft.ref || undefined,
        ft_utm_source:      ft.utm_source   || undefined,
        ft_utm_medium:      ft.utm_medium   || undefined,
        ft_utm_campaign:    ft.utm_campaign || undefined,
        ft_utm_term:        ft.utm_term     || undefined,
        ft_utm_content:     ft.utm_content  || undefined,
        ft_device:          ft.device       || undefined,
        ft_devicemodel:     ft.devicemodel  || undefined,
        ft_product_id:      ft.product_id   || undefined,
        ft_date:            ft.ts_iso       || undefined,

        // Last touch
        lt_bucket:          lt.bucket,
        lt_landing:         lt.landing,
        lt_ref:             lt.ref          || undefined,
        lt_utm_source:      lt.utm_source   || undefined,
        lt_utm_medium:      lt.utm_medium   || undefined,
        lt_utm_campaign:    lt.utm_campaign || undefined,
        lt_utm_term:        lt.utm_term     || undefined,
        lt_utm_content:     lt.utm_content  || undefined,
        lt_device:          lt.device       || undefined,
        lt_devicemodel:     lt.devicemodel  || undefined,
        lt_product_id:      lt.product_id   || undefined,
        lt_date:            lt.ts_iso       || undefined,

        // Metriche di percorso
        visit_count:        visitCount > 0 ? String(visitCount) : undefined,
        days_to_convert:    daysSinceFt > 0 ? String(daysSinceFt) : undefined
      };

      // Rimuovi chiavi vuote/undefined
      Object.keys(attrs).forEach(function (k) {
        if (attrs[k] === undefined || attrs[k] === '') delete attrs[k];
      });

      // ─── Invia a Shopify cart, serializzando i tentativi ────────────────────────
      var payload = JSON.stringify(attrs);
      sendCurrentAttrs = function (force) {
        if (!marketingAllowed()) return Promise.resolve(false);
        if (inFlight) return inFlight;
        if (!force && payload === lsGet(SENT_KEY)) return Promise.resolve(false);

        var request;
        try {
          request = fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          });
        } catch (e) {
          return Promise.resolve(false);
        }

        inFlight = Promise.resolve(request)
          .then(function (response) {
            if (!response.ok) throw new Error('cart attributes update failed');
            if (!marketingAllowed()) return false;
            lsSet(SENT_KEY, payload);
            return true;
          })
          .catch(function () {
            return false;
          })
          .then(function (result) {
            inFlight = null;
            return result;
          });

        return inFlight;
      };

      if (!skipAutomatic) sendCurrentAttrs(false);
    } catch (e) { }
  }
})();
